export function registerComponent(componentName, componentObject) {
  if (ko.components.isRegistered(componentName)) return;

  ko.components.register(componentName, {
    viewModel: {
      createViewModel: (params, componentInfo) => {
        try {
          if ("model" in componentObject) {
            const { model } = componentObject;
            const args = [params, componentInfo.element, componentInfo.templateNodes];
            // Стрелочные функции (TS target ES2022 больше не транспилирует их) нельзя вызывать через new
            return model.prototype ? new model(...args) : model(...args);
          }

          if ("createModel" in componentObject)
            componentObject.createModel(params, componentInfo);
        } catch (e) {
          console.error(e, componentName, componentObject);
          console.trace();
        }
      },
    },
    template: componentObject.template,
  });
}

export function registerComponents(components) {
  Object.entries(components).forEach(([key, value]) =>
    registerComponent(key, value)
  );
}
